import type { CommandFactory } from './types'

export const artifactCommand: CommandFactory = (context) => ({
  id: 'artifact',
  name: 'artifact',
  description: 'Create an HTML artifact from a description',
  acceptsArgs: true,
  handler: async (args?: string) => {
    if (!args || args.trim() === '') {
      context.onDisplayMessage?.({
        role: 'command',
        content:
          'Please provide an artifact description. Usage: `/artifact <your artifact description>`',
        timestamp: new Date(),
      })
      return
    }

    // Submit a message that will prompt the AI to use the create_artifact tool
    context.onSubmitMessage?.(
      `Create an HTML artifact based on this description: ${args.trim()}`
    )
  },
})
